import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { IMachineStatusItemData } from '../../interfaces/Machine.types';
import { StyledMachineStatusIndicatorTooltip } from './MachineStatusIndicatorTooltip.styles';
import { SvgIcon } from 'lib/components/SvgIcon/SvgIcon';

interface MachineStatusIndicatorTooltipProps {
  statusItem: IMachineStatusItemData;
}
export const MachineStatusIndicatorTooltip = ({ statusItem }: MachineStatusIndicatorTooltipProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledMachineStatusIndicatorTooltip className="machine-status-indicator-tooltip">
      <SvgIcon
        name={statusItem.icon}
        className={classnames(
          'machine-status-indicator-tooltip__icon',
          `machine-status-indicator-tooltip__icon--${statusItem.icon}`
        )}
      />
      <div className="machine-status-indicator-tooltip__info">
        <div className="machine-status-indicator-tooltip__title">{t(statusItem.title)}</div>
        <div className="machine-status-indicator-tooltip__description">{t(statusItem.description)}</div>
      </div>
    </StyledMachineStatusIndicatorTooltip>
  );
};
